import SignaturePad from "components/SignaturePad";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Step3 = () => {
  const { t } = useTranslation();
  return (
    <div className={"flex flex-col gap-4 h-full"}>
      <Typography className={"font-bold text-md"}>
        {t("subscriberSignature")}
      </Typography>
      <div className={"w-full flex-1"}>
        <SignaturePad />
      </div>
    </div>
  );
};

export default Step3;
